<template>
  <div class="qa-question-detail-recommed-group" v-if="list && list.length">
    <titleImg
      :icon="require('images/qa/questions/group-title.png')"
      pdb="0rem"
      class="title"
    />
    <div :class="{ list: true, large: list && list.length === 1 }">
      <div v-swiper:myFuckSwiper="swiperOptions" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="swiper-slide list-item"
            @click="goGroupDes(item)"
          >
            <div class="group">
              <img
                :src="item.groupAvatar | imgZip(92, 92)"
                alt=""
                class="group-avatar"
              />
              <div class="group-center">
                <p class="group-name">{{ item.groupName }}</p>
                <div class="flex-align">
                  <div class="group-guan" v-if="+item.isOfficial === 1">
                    官方
                  </div>
                  <div class="group-tag">{{ item.memberCount }}人</div>
                  <template v-if="item.tagNameList && item.tagNameList.length">
                    <div
                      class="group-tag"
                      v-for="tag in item.tagNameList"
                      :key="tag"
                    >
                      #{{ tag }}
                    </div>
                  </template>
                </div>
              </div>
              <button class="group-btn"><span>+</span> 加入</button>
            </div>
            <div class="group-desc">
              {{ item.groupIntro }}
            </div>
          </div>
        </div>
        <div class="swiper-pagination" v-if="list && list.length > 1"></div>
      </div>
    </div>
  </div>
</template>
<script>
import titleImg from 'component/qa/title.vue'
export default {
  components: {
    titleImg
  },
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    goGroupDes(item) {
      this.routerPushWithoutNav(`/appCommunity/groupIndex/${item.groupId}`)
    }
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 'auto',
        spaceBetween: 10,
        observer: true,
        // slidesPerView: 'auto',
        // spaceBetween: 10,
        // effect: 'slide',
        // grabCursor: true,
        // // centeredSlides: true,
        // coverflowEffect: {
        //   rotate: 50,
        //   stretch: 0,
        //   depth: 100,
        //   modifier: 1,
        //   slideShadows: false
        // },
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.qa-question-detail-recommed-group {
  padding-top: 40px;
  .flex-align {
    display: flex;
    align-items: center;
  }
  .title {
    margin: 0 0 0px 32px;
  }
  .list {
    height: 342px;
    width: 100%;
    box-sizing: border-box;
    .swiper-container {
      height: 342px;
      padding: 0 32px;
      box-sizing: border-box;
      .swiper-wrapper {
        padding-top: 40px;
        box-sizing: border-box;
      }
    }
    &-item {
      width: 656px;
      height: 208px;
      padding: 30px;
      background: #ffffff;
      box-shadow: 0px 0px 40px 0px #ebefff;
      border-radius: 30px;
      box-sizing: border-box;
    }
    .group {
      display: flex;
      &-avatar {
        width: 92px;
        height: 92px;
        border-radius: 10px;
        object-fit: cover;
        margin-right: 20px;
      }
      &-center {
        max-width: 350px;
      }
      &-name {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #21252d;
        line-height: 28px;
        margin-bottom: 20px;
        @include overLine(1);
      }

      &-guan {
        display: inline-block;
        width: 56px;
        height: 28px;
        border-radius: 6px;
        border: 1px solid #aab8fa;
        font-size: 22px;
        color: #6982fa;
        line-height: 28px;
        text-align: center;
        margin-right: 10px;
      }
      &-tag {
        display: inline-block;
        padding: 6px 12px;
        background: #f2f4ff;
        border-radius: 10px;
        font-size: 20px;
        color: #21252d;
        line-height: 20px;
        &:not(:nth-last-child(1)) {
          margin-right: 10px;
        }
      }
      &-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        width: 115px;
        height: 52px;
        border-radius: 27px;
        border: 1px solid #6982fa;
        background: transparent;
        font-size: 24px;
        color: #6982fa;
        line-height: 24px;
        span {
          font-size: 26px;
          // font-weight: bold;
          margin-right: 10px;
        }
      }
      &-desc {
        font-size: 24px;
        color: #9da3ac;
        line-height: 36px;
        margin-top: 20px;
        @include overLine(1);
      }
    }
  }
  .large {
    height: 296px;
    .swiper-container {
      height: 296px;
      .swiper-wrapper {
        padding-top: 40px;
        box-sizing: border-box;
      }
    }
    .list-item {
      width: 686px;
    }
  }
}
</style>
<style lang="scss">
.qa-question-detail-recommed-group {
  .swiper-pagination {
    bottom: 42px;
    .swiper-pagination-bullet {
      width: 30px !important;
      height: 6px !important;
      background: #f2f4ff !important;
      opacity: 1 !important;
      margin: 0 !important;
      border-radius: 4px !important;
      &.swiper-pagination-bullet-active {
        opacity: 1 !important;
        background: #a0b0ff !important;
      }
    }
  }
}
</style>
